<template>
    <rkm-modal
        :loading="loading"
        extra-large
        ref="Modal"
        title="Atendimento individual - Inconsistências"
    >
        <template v-if="data">

            <Inconsistencia
                v-if="inconsistenciaVersao"
                :inconsistencias="inconsistenciaVersao"
            />          

            <rkm-area
                title="Profissional responsável"
                type="fieldset"
            >
                <rkm-row>
                    <rkm-col cols="6">
                        <Item
                            label="Nome"
                            :value="data.profissionalResponsavel.campos.profissionalNome"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <Item
                            label="CNS"
                            :value="data.profissionalResponsavel.campos.profissionalCNS"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <Item
                            label="CNES"
                            :value="data.profissionalResponsavel.campos.cnes"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <Item
                            label="IBGE"
                            :value="data.profissionalResponsavel.campos.codigoIbgeMunicipio"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="3">
                        <Item
                            label="INE"
                            :value="data.profissionalResponsavel.campos.ine"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <Item
                            label="CBO"
                            :value="data.profissionalResponsavel.campos.cboCodigo2002"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <Item
                            label="Data"
                            :value="data.profissionalResponsavel.campos.dataAtendimento"
                        />
                    </rkm-col>
                </rkm-row>

                <Inconsistencia :inconsistencias="data.profissionalResponsavel.inconsistencias" />
            </rkm-area>

            <rkm-area
                title="Profissional auxiliar"
                type="fieldset"
            >
                <rkm-row>
                    <rkm-col cols="6">
                        <Item
                            label="Nome"
                            :value="data.profissionalAuxiliar.campos.profissionalNome"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <Item
                            label="CNS"
                            :value="data.profissionalAuxiliar.campos.profissionalCNS"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <Item
                            label="CNES"
                            :value="data.profissionalAuxiliar.campos.cnes"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="6">
                        <Item
                            label="INE"
                            :value="data.profissionalAuxiliar.campos.ine"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <Item
                            label="CBO"
                            :value="data.profissionalAuxiliar.campos.cboCodigo2002"
                        />
                    </rkm-col>
                </rkm-row>

                <Inconsistencia :inconsistencias="data.profissionalAuxiliar.inconsistencias" />
            </rkm-area>

            <rkm-area
                title="Atendimentos"
                type="fieldset"
            >
                <rkm-list
                    hide-pagination
                    hide-filters
                    :items="atendimentosComInconsistencia"
                    class="p-0"
                >                                         
                    <template v-slot="{ item }">
                        <rkm-row>
                            <rkm-col cols="6">
                                <strong>Paciente:</strong> {{ item.paciente.campos.nomeCidadao }}
                            </rkm-col>

                            <rkm-col>
                                <strong>CNS:</strong> {{ item.paciente.campos.cnsCidadao }}
                            </rkm-col>

                            <rkm-col>
                                <strong>Data de nascimento:</strong> {{ item.paciente.campos.dataNascimento }}
                            </rkm-col>
                        </rkm-row>
                    </template>

                    <template v-slot:collapse="{ item }">
                        <div class="p-3">
                            <rkm-area
                                title="Paciente"
                                type="fieldset"
                            >
                                <rkm-row>
                                    <rkm-col>
                                        <Item
                                            label="CNS"
                                            :value="item.paciente.campos.cnsCidadao"
                                        />
                                    </rkm-col>

                                    <rkm-col>
                                        <Item
                                            label="CPF"
                                            :value="item.paciente.campos.cpfCidadao"
                                        />
                                    </rkm-col>

                                    <rkm-col>
                                        <Item
                                            label="Data de nascimento"
                                            :value="item.paciente.campos.dataNascimento"
                                        />
                                    </rkm-col>

                                    <rkm-col>
                                        <Item
                                            label="Sexo"
                                            :value="item.paciente.campos.sexo"
                                        />
                                    </rkm-col>

                                    <rkm-col>
                                        <Item
                                            label="Prontuário"
                                            :value="item.paciente.campos.numeroProntuario"
                                        />
                                    </rkm-col>
                                </rkm-row>

                                <Inconsistencia :inconsistencias="item.paciente.inconsistencias" />
                            </rkm-area>

                            <rkm-area
                                title="Atendimento"
                                type="fieldset"
                            >
                                <rkm-row>
                                    <rkm-col cols="3">
                                        <Item
                                            label="Turno"
                                            :value="item.atendimento.campos.turno"
                                        />
                                    </rkm-col>

                                    <rkm-col cols="3">
                                        <Item
                                            label="Local de atendimento"
                                            :value="item.atendimento.campos.localDeAtendimento"
                                        />
                                    </rkm-col>

                                    <rkm-col cols="3">
                                        <Item
                                            label="Tipo de atendimento"
                                            :value="item.atendimento.campos.tipoAtendimento"
                                        />
                                    </rkm-col>

                                    <rkm-col cols="3">
                                        <Item
                                            label="Vacinação em dia"
                                            :value="item.atendimento.campos.vacinaEmDia"
                                        />
                                    </rkm-col>
                                </rkm-row>

                                <rkm-row>
                                    <rkm-col cols="3">
                                        <Item
                                            label="Atenção domiciliar"
                                            :value="item.atendimento.campos.atencaoDomiciliarModalidade"
                                        />
                                    </rkm-col>

                                    <rkm-col cols="3">
                                        <Item
                                            label="Criança - Aleitamento materno"
                                            :value="item.atendimento.campos.aleitamentoMaterno"
                                        />
                                    </rkm-col>

                                    <rkm-col cols="6">
                                        <Item
                                            label="Racionalidade em saúde (Exceto alopatia / convencional)"
                                            :value="item.atendimento.campos.racionalidadeSaude"
                                        />
                                    </rkm-col>
                                </rkm-row>

                                <rkm-row>
                                    <rkm-col cols="6">
                                        <Item
                                            label="Data/hora inicial do atendimento"
                                            :value="item.atendimento.campos.dataHoraInicialAtendimento"
                                        />
                                    </rkm-col>

                                    <rkm-col cols="6">
                                        <Item
                                            label="Data/hora final do atendimento"
                                            :value="item.atendimento.campos.dataHoraFinalAtendimento"
                                        />
                                    </rkm-col>
                                </rkm-row>

                                <Inconsistencia :inconsistencias="item.atendimento.inconsistencias" />
                            </rkm-area>

                            <rkm-area
                                title="Medições"
                                type="fieldset"
                            >
                                <rkm-row>
                                    <rkm-col cols="3">
                                        <Item
                                            label="Circunferência abdominal"
                                            :value="item.medicoes.campos.circunferenciaAbdominal"
                                            append="cm"
                                        />
                                    </rkm-col>

                                    <rkm-col cols="3">
                                        <Item
                                            label="Perímetro da panturrilha"
                                            :value="item.medicoes.campos.perimetroPanturrilha"
                                            append="cm"
                                        />
                                    </rkm-col>

                                    <rkm-col cols="3">
                                        <Item
                                            label="Pressão arterial"
                                            :value="item.medicoes.campos.pressaoArterial"
                                            append="mmHg"
                                        />
                                    </rkm-col>

                                    <rkm-col cols="3">
                                        <Item
                                            label="Frequência respiratória"
                                            :value="item.medicoes.campos.frequenciaRespiratoria"
                                            append="mpm"
                                        />
                                    </rkm-col>
                                </rkm-row>

                                <rkm-row>
                                    <rkm-col cols="3">
                                        <Item
                                            label="Frequência cardíaca"
                                            :value="item.medicoes.campos.frequenciaCardiaca"
                                            append="bpm"
                                        />
                                    </rkm-col>

                                    <rkm-col cols="3">
                                        <Item
                                            label="Temperatura"
                                            :value="item.medicoes.campos.temperatura"
                                            append="°C"
                                        />
                                    </rkm-col>

                                    <rkm-col cols="3">
                                        <Item
                                            label="Saturação de O2"
                                            :value="item.medicoes.campos.saturacaoO2"
                                            append="%"
                                        />
                                    </rkm-col>

                                    <rkm-col cols="3">
                                        <Item
                                            label="Peso"
                                            :value="item.medicoes.campos.peso"
                                            append="kg"
                                        />
                                    </rkm-col>
                                </rkm-row>

                                <rkm-row>
                                    <rkm-col cols="3">
                                        <Item
                                            label="Altura"
                                            :value="item.medicoes.campos.altura"
                                            append="cm"
                                        />
                                    </rkm-col>

                                    <rkm-col cols="3">
                                        <Item
                                            label="Perímetro cefálico"
                                            :value="item.medicoes.campos.perimetroCefalico"
                                            append="cm"
                                        />
                                    </rkm-col>

                                    <rkm-col cols="3">
                                        <Item
                                            label="Glicemia capilar"
                                            :value="item.medicoes.campos.glicemiaCapilar"
                                            append="mg/dL"
                                        />
                                    </rkm-col>

                                    <rkm-col cols="3">
                                        <Item
                                            label="Momento da coleta"
                                            :value="item.medicoes.campos.tipoGlicemiaCapilar"
                                        />
                                    </rkm-col>
                                </rkm-row>

                                <Inconsistencia :inconsistencias="item.medicoes.inconsistencias" />
                            </rkm-area>

                            <rkm-area
                                v-if="item.paciente.campos.isSexoFeminino"
                                title="Gestante"
                                type="fieldset"
                            >
                                <rkm-row>
                                    <rkm-col cols="3">
                                        <Item
                                            label="DUM"
                                            :value="item.gestante.campos.dumDaGestante"
                                        />
                                    </rkm-col>

                                    <rkm-col cols="3">
                                        <Item
                                            label="Idade gestacional"
                                            :value="item.gestante.campos.idadeGestacional"
                                            append="Semanas"
                                        />
                                    </rkm-col>

                                    <rkm-col cols="2">
                                        <Item
                                            label="Gravidez planejada"
                                            :value="item.gestante.campos.stGravidezPlanejada"
                                        />
                                    </rkm-col>

                                    <rkm-col cols="2">
                                        <Item
                                            label="Gestações prévias"
                                            :value="item.gestante.campos.nuGestasPrevias"
                                        />
                                    </rkm-col>

                                    <rkm-col cols="2">
                                        <Item
                                            label="Partos"
                                            :value="item.gestante.campos.nuPartos"
                                        />
                                    </rkm-col>
                                </rkm-row>

                                <Inconsistencia :inconsistencias="item.gestante.inconsistencias" />
                            </rkm-area>

                            <rkm-area
                                title="Problema / Condição avaliada"
                                type="fieldset"
                            >
                                <rkm-list
                                    :items="item.problemasCondicoes.lista"
                                    class="p-0"
                                    hide-filters
                                    hide-pagination
                                    item-cursor="default"
                                >
                                    <template v-slot="{ item }">
                                        <rkm-row>
                                            <rkm-col cols="6">
                                                <strong>CIAP:</strong> {{ item.campos.ciap }}
                                            </rkm-col>

                                            <rkm-col cols="6">
                                                <strong>CID:</strong> {{ item.campos.cid10 }}
                                            </rkm-col>
                                        </rkm-row>

                                        <rkm-row>
                                            <rkm-col cols="3">
                                                 <strong>Situação:</strong> {{ item.campos.situacao }}
                                            </rkm-col>

                                            <rkm-col cols="3">
                                                <strong>Início:</strong> {{ item.campos.dataInicioProblema }}
                                            </rkm-col>

                                            <rkm-col cols="3">
                                                <strong>Fim:</strong> {{ item.campos.dataFimProblema }}
                                            </rkm-col>

                                            <rkm-col cols="3">
                                                <strong>Avaliado:</strong> {{ item.campos.isAvaliado }}
                                            </rkm-col>
                                        </rkm-row>

                                        <Inconsistencia :inconsistencias="item.inconsistencias" />
                                    </template>
                                </rkm-list>

                                <Inconsistencia :inconsistencias="item.problemasCondicoes.inconsistencias" />                                
                            </rkm-area>

                            <rkm-area
                                title="Exames Solicitados e Avaliados"
                                type="fieldset"
                            >
                                <rkm-table
                                    hide-filters
                                    hide-pagination
                                    :items="item.exames.lista"
                                    :fields="[
                                        { key: 'nome', label: 'Nome' },
                                        { key: 'isSolicitado', label: 'Solicitado' },
                                        { key: 'isAvaliado', label: 'Avaliado' },
                                    ]"
                                />

                                <Inconsistencia :inconsistencias="item.exames.inconsistencias" />
                            </rkm-area>

                            <rkm-area
                                title="Ficou em observação?"
                                type="fieldset"
                            >
                                <rkm-row>
                                    <rkm-col cols="3">
                                        <Item
                                            :value="item.observacao.campos.ficouEmObservacao"
                                        />
                                    </rkm-col>
                                </rkm-row>

                                <Inconsistencia :inconsistencias="item.observacao.inconsistencias" />
                            </rkm-area>

                            <rkm-area
                                title="EMULTI / Polo"
                                type="fieldset"
                            >
                                <rkm-table
                                    hide-filters
                                    hide-pagination
                                    :items="item.emultis.lista.map(value => ({ value }))"
                                    :fields="[{ key: 'value', label: 'EMULTI / Polo' }]"
                                />

                                <Inconsistencia :inconsistencias="item.emultis.inconsistencias" />
                            </rkm-area>

                            <rkm-area
                                title="Conduta / Desfecho"
                                type="fieldset"
                            >
                                <rkm-table
                                    hide-filters
                                    hide-pagination
                                    :items="item.condutas.lista.map(value => ({ value }))"
                                    :fields="[{ key: 'value', label: 'Conduta' }]"
                                />

                                <Inconsistencia :inconsistencias="item.condutas.inconsistencias" />
                            </rkm-area>

                            <rkm-area
                                title="IVCF - Índice de vulnerabilidade clínico-funcional"
                                type="fieldset"
                            >
                                <rkm-row>
                                    <rkm-col>
                                        <Item
                                            :value="item.ivcf.campos.resultado"
                                            label="Resultado"
                                        />
                                    </rkm-col>

                                    <rkm-col>
                                        <Item
                                            :value="item.ivcf.campos.hasSgIdade"
                                            label="Idade"
                                        />
                                    </rkm-col>

                                    <rkm-col>
                                        <Item
                                            :value="item.ivcf.campos.hasSgPercepcaoSaude"
                                            label="Percepção de saúde"
                                        />
                                    </rkm-col>

                                    <rkm-col>
                                        <Item
                                            :value="item.ivcf.campos.hasSgAvdInstrumental"
                                            label="Atividades instrumentais da vida diária"
                                        />
                                    </rkm-col>
                                </rkm-row>

                                <rkm-row>
                                    <rkm-col>
                                        <Item
                                            :value="item.ivcf.campos.hasSgAvdBasica"
                                            label="Atividades básicas da vida diária"
                                        />
                                    </rkm-col>

                                    <rkm-col>
                                        <Item
                                            :value="item.ivcf.campos.hasSgCognicao"
                                            label="Cognição"
                                        />
                                    </rkm-col>

                                    <rkm-col>
                                        <Item
                                            :value="item.ivcf.campos.hasSgHumor"
                                            label="Humor"
                                        />
                                    </rkm-col>

                                    <rkm-col>
                                        <Item
                                            :value="item.ivcf.campos.hasSgAlcancePreensaoPinca"
                                            label="Alcance preensão pinça"
                                        />
                                    </rkm-col>
                                </rkm-row>

                                <rkm-row>
                                    <rkm-col>
                                        <Item
                                            :value="item.ivcf.campos.hasSgCapAerobicaMuscular"
                                            label="Capacidade aeróbica muscular"
                                        />
                                    </rkm-col>

                                    <rkm-col>
                                        <Item
                                            :value="item.ivcf.campos.hasSgMarcha"
                                            label="Marcha"
                                        />
                                    </rkm-col>

                                    <rkm-col>
                                        <Item
                                            :value="item.ivcf.campos.hasSgContinencia"
                                            label="Continência"
                                        />
                                    </rkm-col>

                                    <rkm-col>
                                        <Item
                                            :value="item.ivcf.campos.hasSgVisao"
                                            label="Visão"
                                        />
                                    </rkm-col>
                                </rkm-row>

                                <rkm-row>
                                    <rkm-col>
                                        <Item
                                            :value="item.ivcf.campos.hasSgAudicao"
                                            label="Audição"
                                        />
                                    </rkm-col>

                                    <rkm-col>
                                        <Item
                                            :value="item.ivcf.campos.hasSgComorbidade"
                                            label="Comorbidade"
                                        />
                                    </rkm-col>

                                    <rkm-col>
                                        <Item
                                            :value="item.ivcf.campos.dataResultado"
                                            label="Data do resultado"
                                        />
                                    </rkm-col>
                                </rkm-row>

                                <Inconsistencia :inconsistencias="item.ivcf.inconsistencias" />
                            </rkm-area>

                            <rkm-area
                                title="Solicitações OCI"
                                type="fieldset"
                            >
                                <rkm-table
                                    hide-filters
                                    hide-pagination
                                    :items="item.solicitacoesOci.lista"
                                    :fields="[
                                        { key: 'codigoSigtap', label: 'Código do procedimento' },
                                    ]"
                                />

                                <Inconsistencia :inconsistencias="item.solicitacoesOci.inconsistencias" />
                            </rkm-area>
                        </div>
                    </template>
                </rkm-list>

                <Inconsistencia :inconsistencias="data.atendimentos.inconsistencias" />
            </rkm-area>
        </template>

        <template #footer>
            <rkm-button
                :disabled="!!loading"
                @click="handleExit"
            >
                Fechar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Components.
import Item from '../item/Index'
import Inconsistencia from '../inconsistencia/Index'

// Mixins.
import { repository, error } from '@/mixins'

// Vuex.
import { mapActions, mapGetters } from 'vuex'

export default {
    components: { Item, Inconsistencia },
    computed: {
        ...mapGetters({ loading: 'getLoading' }),

        inconsistenciaVersao(){

            const texto = this.inconsistencia?.inconsistencia || ''

            const versaoErro = this.extrairVersaoDescricao(texto)
            const versao = this.extrairVersao(texto)

            if(!versaoErro) return []

            return [
                `A versão atual do LEDI (${versao}) não é compatível com a versão do seu integrador.`
            ]

        },
        atendimentosComInconsistencia(){
            return this.data.atendimentos.lista.map(item => ({
                ...item,
                _listItemColor: this.isInconsistencia(item) ? 'danger': ''
            }))
        },
    },
    created() {

        this.repositories = {
            gerenciamentoEnvio: this.getConectaSusRepository('integracao.esus.gerenciamentoEnvio'),
        }
    },
    data: () => ({
        inconsistencia: null,
        data: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open(inconsistencia) {

            this.inconsistencia = inconsistencia
            this.data = null

            this.load()
            this.$refs.Modal.show()
        },
        handleExit() {

            this.$refs.Modal.hide()
        },
        load() {

            this.setLoading()

            this.repositories.gerenciamentoEnvio.getInconsistencia(this.inconsistencia.id)
                .then(({ data }) => this.data = data)
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        isInconsistencia(item){

            const blocos = [
                item.atendimento,
                item.condutas,
                item.emultis,
                item.exames,
                item.gestante,
                item.ivcf,
                item.medicoes,
                item.observacao,
                item.paciente,
                item.solicitacoesOci
            ]

            const problemasCondicoesComInconsistencia =
                (item.problemasCondicoes?.inconsistencias?.length || 0) > 0 ||
                item.problemasCondicoes?.lista?.some(
                    problema => (problema?.inconsistencias?.length || 0) > 0
                )

            return blocos.some(b => (b?.inconsistencias?.length || 0) > 0)
                || problemasCondicoesComInconsistencia

        },
        extrairVersaoDescricao(texto) {

            if (!texto) return null

            texto = texto.replace(/\\u00e3/g, 'ã')

            const match = texto.match(/vers[aã]o\s+([\d.]+)\s+inexistente/i)

            return match ? match[1] : null
        },

        extrairVersao(texto){
            if (!texto) return null

            const match = texto.match(/\d+\.\d+\.\d+/)

            return match ? match[0] : null
        }
    },
    mixins: [repository, error]
}
</script>